import { render, staticRenderFns } from "./record-video-kid.vue?vue&type=template&id=7622eb6d&scoped=true"
import script from "./record-video-kid.vue?vue&type=script&lang=js"
export * from "./record-video-kid.vue?vue&type=script&lang=js"
import style0 from "./record-video-kid.vue?vue&type=style&index=0&id=7622eb6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7622eb6d",
  null
  
)

export default component.exports